import { createContext } from 'react';
import { GetAccountsRatesParams } from '@goldwasserexchange/actor/rest-services';

export const accountsRatesParamsContext = createContext<Partial<GetAccountsRatesParams>>({});
